import { useContext, useState } from 'react'
import {
    StyleButtonWrapper,
    StyledActionGroup,
    StyledCheckboxGroup,
    StyledDeleteAccount,
} from './DeleteAccount.styled'
import { MyAccountContext } from '../hooks/useMyAccountContext'
import React from 'react'
import { TNCheckbox } from '../components/TNCheckbox'
import { metrics } from '../../__styling'
import { TNLink } from '../components/TNLink'
import { TNButton } from '../components/TNButton'
import { tokens } from '@news-mono/design-tokens'
import {
    DeleteAccountClickProps,
    onDeleteAccountClick,
} from './helpers/delete-account-click-helper'
import { useDeleteAccount } from '../hooks/useDeleteAccount'
import { useSelector } from 'react-redux'
import { AppState, ConfigurationContext } from '@news-mono/web-common'

const { utility } = tokens.thenightly.colors.palette

export const DeleteAccountAcknowledge = () => {
    const [confirmDeletion, setConfirmDeletion] = useState<boolean>(false)
    const [submitting, setSubmitting] = useState<boolean>(false)

    // contexts for the account deletion
    const myAccountContext = useContext(MyAccountContext)
    const { setScreen, setScreenSelected } = myAccountContext
    const config = useContext(ConfigurationContext)

    const { userEmail, wanUserId, loginProvider } = useSelector(
        (state: AppState) => state.authentication,
    )

    // back-end handler for the delete account functionality
    const { mutateAsync: deleteAccount } = useDeleteAccount({
        userId: wanUserId,
        email: userEmail!,
        currentPassword: config.passEncryptionKey!,
        passEncryptionKey: config.passEncryptionKey!,
    })

    // props to pass through to the client-side deleteAccount helper
    const deleteAccountProps: DeleteAccountClickProps = {
        myAccountContext,
        configContext: config,
        mutateProps: {
            onDeleteAccount: deleteAccount,
            sendForgotPasswordEmail: () => {},
        },
        passwordState: {
            passwordText: config.passEncryptionKey,
        },
    }

    return (
        <StyledDeleteAccount>
            <p>Before proceeding, please acknowledge the following:</p>
            <StyledCheckboxGroup>
                <TNCheckbox
                    name="understand-erase-data"
                    label="I wish to delete my account."
                    checked={confirmDeletion}
                    width={'fit-content'}
                    size={metrics.thenightly.margins.m2l}
                    onChange={() => setConfirmDeletion(!confirmDeletion)}
                />
            </StyledCheckboxGroup>
            <StyledActionGroup>
                <TNLink
                    color={utility.error.default}
                    onClick={async () => {
                        // Make sure the confirmation box is ticked
                        if (confirmDeletion) {
                            // If the login provider is Auth0, continue to the password screen
                            if (loginProvider === 'Auth0') {
                                setScreen('delete-account-password')
                            } else {
                                // While it's trying to submit, set the state accordingly
                                setSubmitting(true)
                                await onDeleteAccountClick(deleteAccountProps)
                                setSubmitting(false)
                            }
                        }
                    }}
                    disabled={!confirmDeletion || submitting}
                    fontWeight={600}
                    underline={false}
                >
                    DELETE MY ACCOUNT
                </TNLink>
                <StyleButtonWrapper>
                    <TNButton
                        onClick={() => {
                            setScreen('manage-account')
                            setScreenSelected(true)
                        }}
                        btnType="primary"
                        disabled={submitting}
                    >
                        CANCEL
                    </TNButton>
                </StyleButtonWrapper>
            </StyledActionGroup>
        </StyledDeleteAccount>
    )
}
